<div class="line-stats-container">
  @for (item of lineCounts(); track item.line) {
    <div
      class="stat-row"
      [attr.data-line]="item.line"
      [class.is-stat-clickable]="isStatClickable(item.gates)"
      [class.is-stat-frozen]="isStatFrozen(item.key)"
      [attr.title]="isStatClickable(item.gates) ? statTooltip(item.key) : null"
      (click)="onStatClick(item.key, item.gates)"
    >
      @if (isStatFrozen(item.key)) {
        <i class="fa-solid fa-snowflake stat-freeze-icon"></i>
      }
      <span class="line-label">
        <b>{{ item.line }}<sup>{{ labels().ordinalLineSuffix[item.line] }}</sup></b>&nbsp;<b>{{ labels().lines }}</b>
      </span>
      <span class="count-values">
        @if (selectedSide() === null) {
          <span class="count-value">{{ item.count }}x</span>
        } @else {
          @if (item.count !== item.selectedCount) {
            <span class="count-value count-value--overall" aria-hidden="true">{{ item.count }}x</span>
          }
          <span class="count-value count-value--selected" [style.color]="selectedColor()">
            {{ item.selectedCount }}x
          </span>
        }
      </span>
    </div>
  }

  <div class="spacer"></div>

  <div
    class="stat-row"
    data-activation-stat="dormant"
    [class.is-stat-clickable]="isStatClickable(activationStats().dormant.gates)"
    [class.is-stat-frozen]="isStatFrozen(dormantStatKey)"
    [attr.title]="isStatClickable(activationStats().dormant.gates) ? statTooltip(dormantStatKey) : null"
    (click)="onStatClick(dormantStatKey, activationStats().dormant.gates)"
  >
    @if (isStatFrozen(dormantStatKey)) {
      <i class="fa-solid fa-snowflake stat-freeze-icon"></i>
    }
    <span class="activation-label"><b>{{ labels().dormant }}:</b></span>
    <span class="count-values">
      @if (selectedSide() === null) {
        <span class="count-value">{{ activationStats().dormant.count }}x</span>
      } @else {
        @if (activationStats().dormant.count !== activationStats().dormant.selectedCount) {
          <span class="count-value count-value--overall" aria-hidden="true">
            {{ activationStats().dormant.count }}x
          </span>
        }
        <span class="count-value count-value--selected" [style.color]="selectedColor()">
          {{ activationStats().dormant.selectedCount }}x
        </span>
      }
    </span>
  </div>
  <div
    class="stat-row"
    data-activation-stat="defined"
    [class.is-stat-clickable]="isStatClickable(activationStats().defined.gates)"
    [class.is-stat-frozen]="isStatFrozen(definedStatKey)"
    [attr.title]="isStatClickable(activationStats().defined.gates) ? statTooltip(definedStatKey) : null"
    (click)="onStatClick(definedStatKey, activationStats().defined.gates)"
  >
    @if (isStatFrozen(definedStatKey)) {
      <i class="fa-solid fa-snowflake stat-freeze-icon"></i>
    }
    <span class="activation-label"><b>{{ labels().defined }}:</b></span>
    <span class="count-values">
      @if (selectedSide() === null) {
        <span class="count-value">{{ activationStats().defined.count }}x</span>
      } @else {
        @if (activationStats().defined.count !== activationStats().defined.selectedCount) {
          <span class="count-value count-value--overall" aria-hidden="true">
            {{ activationStats().defined.count }}x
          </span>
        }
        <span class="count-value count-value--selected" [style.color]="selectedColor()">
          {{ activationStats().defined.selectedCount }}x
        </span>
      }
    </span>
  </div>
</div>
